import { Field, useFormikContext } from 'formik';
import { FunctionComponent, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { config } from '../../../utils/config';
import OptionsField from '../../formik/OptionsField';
import { EmbeddedAuthBaseProps } from '../../organisms/EmbeddedAuth';
import Guest from './Guest';
import Register from './Register';
import SignIn from './SignIn';
import './style.scss';

const authOptions: { key: string; form: FunctionComponent<EmbeddedAuthBaseProps> }[] = [
  { key: 'signIn', form: SignIn },
  { key: 'register', form: Register },
  { key: 'guest', form: Guest },
];

const AuthStepOptions = ({ isEmbeddedAuth }: EmbeddedAuthBaseProps) => {
  const { formatMessage } = useIntl();
  const { setTouched } = useFormikContext();

  const options = useMemo(
    () =>
      authOptions
        .filter(auth => (!config.features.guestCheckout.enabled || isEmbeddedAuth ? auth.key !== 'guest' : true))
        .map(({ key, form: Form }) => ({
          key,
          label: formatMessage({ id: `auth.options.${key}.label` }),
          form: () => <Form isEmbeddedAuth={isEmbeddedAuth} />,
        })),
    []
  );

  return (
    <div className="auth-step-options">
      <Field
        name="type"
        component={OptionsField}
        options={options}
        isVertical
        dataTestIdPrefix="authOptions"
        onChange={() => setTouched({}, false)}
      />
    </div>
  );
};

export default AuthStepOptions;
